export default __webpack_public_path__ + "static/media/emails.38a9ce97.png";